import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
export const TableContainer = React.forwardRef((props, ref) => (_jsx("div", Object.assign({ ref: ref, className: classNames(['border rounded overflow-hidden position-relative', props.className]) }, { children: props.children }))));
TableContainer.displayName = 'TableContainer'; // Added this to fix an eslint problem, but might be a false positive? https://github.com/yannickcr/eslint-plugin-react/issues/2269
